module.exports = __webpack_public_path__ + "static/media/voting-bg.aaeae428.jpg";